export default "__VITE_ASSET__7SfghXR$__"